import { ChevronDown } from "lucide-react"

import { useAuth } from "@/store/auth"
import { useDialogs, type DialogNames } from "@/hooks/use-dialogs"
import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

import Dialogs from "./dialogs"

export function StaffNav() {
  const dialogs = useDialogs<DialogNames<typeof Dialogs>>()
  const { user } = useAuth()

  return (
    <>
      <div className="h-8 w-px bg-border" />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="h-12 gap-3 rounded-full py-1 pl-1 pr-2"
          >
            <Avatar className="size-10">
              <AvatarFallback className="bg-gradient-to-br from-teal-600 to-navy-800 text-sm font-bold text-white">
                {`${user?.firstName.charAt(0)}${user?.lastName.charAt(0)}`.toUpperCase()}
              </AvatarFallback>
            </Avatar>
            <div className="flex flex-col items-start">
              <span className="text-sm font-bold leading-tight text-foreground">
                {user?.fullName}
              </span>
              <span className="text-xs leading-tight text-muted-foreground">
                {user?.email}
              </span>
            </div>
            <ChevronDown className="size-4 shrink-0 text-muted-foreground" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-56"
          align="end"
          forceMount
          onCloseAutoFocus={e => e.preventDefault()}
        >
          <DropdownMenuLabel className="font-normal">
            <div className="flex flex-col space-y-1">
              <p className="text-sm font-medium leading-none">
                {user?.fullName}
              </p>
              <p className="text-xs leading-none text-muted-foreground">
                {user?.email}
              </p>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            <DropdownMenuItem onClick={dialogs.toggle("ChangePasswordDialog")}>
              Change Password
            </DropdownMenuItem>
            {/* <ThemeDropdownMenuSub /> */}
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={dialogs.toggle("SignOutConfirmation")}>
            Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <Dialogs.SignOutConfirmation
        {...dialogs.getProps("SignOutConfirmation")}
      />
      <Dialogs.ChangePasswordDialog
        {...dialogs.getProps("ChangePasswordDialog")}
      />
    </>
  )
}
